module.exports = __webpack_public_path__ + "static/img/6.602bfcc5.png";